import React, { memo, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { Avatar, makeStyles } from '@material-ui/core'

import ImagePlaceholder from './ImagePlaceholder'
import SearchAnyProductIcon from '~/components/SearchAnyProductIcon'
import imageOff from '~/assets/image-off.svg'
import { mountUrl, replaceImagePath } from '~/utils'
import { viewSelector } from '~/selectors'
import { useLiterals } from '~/components/Literals'
import { useIntersectionObserver } from './useIntersectionObserver'

const useStyles = makeStyles((theme) => ({
  avatar: {
    background: '#FFF',
    '&.bg': {
      background: theme.palette.secondary.main,
    },
  },
  productWithoutImage: {
    width: '120px',
    height: '120px',
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'center',
    backgroundColor: '#F2F2F2',
    flexShrink: 0,

    '& span': {
      color: '#698387',
      fontSize: 10,
      fontWeight: 700,
      textTransform: 'uppercase',
      marginTop: 8,
    },
  },
  productImage: {
    width: 120,
    height: 120,
  },
}))

function ProductImageThumb({ product, isAvatar }) {
  const view = useSelector(viewSelector)
  const classes = useStyles()
  const image = replaceImagePath(product)
  const { getLiteral } = useLiterals()

  const [hasBeenIntersecting, setHasBeenIntersecting] = useState(false)
  const { ref, isIntersecting } = useIntersectionObserver({
    threshold: 0.1,
    triggerOnce: true,
  })

  useEffect(() => {
    if (isIntersecting) setHasBeenIntersecting(true)
  }, [isIntersecting])

  if (!image) {
    return (
      <>
        {view === 'VIEW_STORES' || isAvatar ? (
          <Avatar>
            <SearchAnyProductIcon />
          </Avatar>
        ) : (
          <div className={classes.productWithoutImage}>
            <img src={imageOff} alt="produto sem imagem" width={42} height={42} loading="lazy" />
            <span>{getLiteral('1170')}</span>
          </div>
        )}
      </>
    )
  }

  return (
    <div ref={ref}>
      {hasBeenIntersecting ? (
        <ImagePlaceholder src={mountUrl(image, { height: 360 })} placeholder={mountUrl(image, { height: 360 })}>
          {(src, loading) =>
            loading ? (
              <Avatar className={classes.avatar}>
                <SearchAnyProductIcon />
              </Avatar>
            ) : (
              <>
                {view === 'VIEW_STORES' || isAvatar ? (
                  <Avatar className={classes.avatar} src={src} alt={product.name} />
                ) : (
                  <div className={classes.productImage}>
                    <img
                      src={src}
                      alt={product.name}
                      width={120}
                      height={120}
                      style={{ objectFit: 'contain', mixBlendMode: 'multiply' }}
                    />
                  </div>
                )}
              </>
            )
          }
        </ImagePlaceholder>
      ) : (
        <Avatar className={classes.avatar}>
          <SearchAnyProductIcon />
        </Avatar>
      )}
    </div>
  )
}

export default memo(ProductImageThumb)
